<template>
  <CRow>
    <CCol col="12">
      <CCard v-if="itemData">
        <CCardHeader> الاجابةة رقم: {{ $route.params.id }} </CCardHeader>
        <CCardBody>

          <CAlert color="info">
            <CRow>
              <CCol col="2">الاجابة</CCol>
              <CCol col="10" v-html="itemData.description"></CCol>
            </CRow>
          </CAlert>

          <CAlert color="info">
            <CRow>
              <CCol col="2">المحامي</CCol>
              <CCol col="10"> {{ itemData.lawyer }} </CCol>
            </CRow>
          </CAlert>

          <CAlert color="info">
            <CRow>
              <CCol col="2">السؤال </CCol>
              <CCol col="10">
                <div v-html="itemData.question"></div>
              </CCol>
            </CRow>
          </CAlert>

          <CAlert color="info">
            <CRow>
              <CCol col="2"> الحالة </CCol>
              <CCol col="10">
                <b :class="`text-${getBadge(itemData.status)}`">
                  {{ itemData.status }}
                  <CButton v-if="(itemData.status == 0)" class="mx-2" color="success" @click="updateStatus(1, itemData.id)">
                    تفعيل
                  </CButton>
                  <CButton v-else color="danger" class="mx-2" @click="updateStatus(0, itemData.id)">
                    ايقاف
                  </CButton>
                </b>
              </CCol>
            </CRow>
          </CAlert>
        </CCardBody>
        <CCardFooter>
          <CButton color="info" @click="goBack">رجوع</CButton>

        </CCardFooter>
      </CCard>
      <Spinner v-else />
    </CCol>
  </CRow>
</template>

<script>
export default {
  name: "Answer",
  data() {
    return {
      itemData: null,
      usersOpened: null,
    };
  },
  created() {
    this.getAnswer();
  },
  methods: {
    getAnswer() {
      this.toggleLoadSpinner();

      this.$http
        .get("answers/" + this.$route.params.id)
        .then((res) => {
          // handle success
          this.itemData = res.data.data;
          this.toggleLoadSpinner();
        })
        .catch((error) => {
          //
          this.toggleLoadSpinner();
        });
    },
    toggleLoadSpinner() {
      this.$store.commit("toggleLoadSpinner");
    },
    goBack() {
      this.$router.push({ path: "/answers" });
    },
    getBadge(status) {
      switch (status) {
        case 1:
          return "success";
        case 0:
          return "danger";
        default:
          return "primary";
      }
    },

    updateStatus(status, id) {
      this.toggleLoadSpinner();
      this.$http
        .put(`/answers/status/${id}`, { status })
        .then((res) => {
          this.itemData = res.data.data;
          this.toggleLoadSpinner();
        })
        .catch((error) => {
          // handle error
          this.toggleLoadSpinner();
        });
    }
  },
};
</script>
